import { csrftoken } from './cookies';

export const verifyEmail = email =>{
	let atposition=email.indexOf("@"); 
	let dotposition=email.lastIndexOf(".");

	if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){		
		return false
	}
	return true
}


// Example POST method implementation:
export const postData = async function(url = '', data = {}, request_method='POST') {
  // Default options are marked with *
  const response = await fetch(url, {
    method: request_method, //'POST',  *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  });
  let packet = {
    status: response.status,
    body: await response.json()
  }
  return packet; // parses JSON response into native JavaScript objects
}